"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function useFetch(settings) {
  let dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let condition = arguments.length > 2 ? arguments[2] : undefined;
  let getDataAsResult = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  const [result, setResult] = (0, _react.useState)({
    _loading: true
  });
  let {
    authorization = false,
    data,
    headers = {},
    method = "GET",
    url
  } = settings;
  const _dependencies = (0, _isArray.default)(dependencies) ? [JSON.stringify(dependencies)] : dependencies;

  // check if settings === string

  if (typeof settings === "string") {
    url = settings;
  }
  if (authorization && localStorage.getItem("logintoken")) {
    headers["Authorization"] = "Bearer " + localStorage.getItem("logintoken");
  }
  (0, _react.useEffect)(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    /**
     * fetch GET
     * params: url
     */

    const fetchGET = async () => {
      const params = [];
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          params.push("".concat(key, "=").concat(data[key]));
        }
      }
      let urlParams = "";
      if (params.length > 0) {
        urlParams = url.indexOf("?") > -1 ? "&" + params.join("&") : "?" + params.join("&");
      }
      try {
        const request = await _axios.default.get(url + urlParams, {
          headers,
          signal
        });
        setResult(getDataAsResult && request.data ? request === null || request === void 0 ? void 0 : request.data : request);
      } catch (error) {
        setResult({
          _error: true,
          _msg: error
        });
      }
    };

    /**
     * fetch POST
     * params: url, data
     */

    const fetchPOST = async () => {
      try {
        const request = await _axios.default.post(url, data, {
          headers,
          signal
        });
        setResult(getDataAsResult && request.data ? request === null || request === void 0 ? void 0 : request.data : request);
      } catch (error) {
        setResult({
          _error: true,
          _msg: error
        });
      }
    };

    /**
     * fetch GET
     * params: url
     */

    const fetchFORMDATA = async () => {
      const params = new FormData();
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          params.append(key, data[key]);
        }
      }
      try {
        const request = await _axios.default.post(url, params, {
          headers,
          signal
        });
        setResult(getDataAsResult && request.data ? request === null || request === void 0 ? void 0 : request.data : request);
      } catch (error) {
        setResult({
          _error: true,
          _msg: error
        });
      }
    };
    if (typeof condition === "boolean" && !condition) {
      return;
    }
    if (method.toUpperCase() === "GET") {
      setResult(prevResult => ({
        ...prevResult,
        _loading: true
      }));
      fetchGET();
      return;
    }
    if (method.toUpperCase() === "POST") {
      setResult(prevResult => ({
        ...prevResult,
        _loading: true
      }));
      fetchPOST();
      return;
    }
    if (method.toUpperCase() === "FORMDATA") {
      setResult(prevResult => ({
        ...prevResult,
        _loading: true
      }));
      fetchFORMDATA();
      return;
    }
    return () => {
      controller.abort();
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  _dependencies);
  return result;
}
var _default = exports.default = useFetch;